import { InfoOutlined } from '@mui/icons-material'
import { Box, Button, Container, Fade, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { DoubleArrow } from '@mui/icons-material'
import { getSeminars, toggleFormSeminar } from '../../../../../redux/actions/seminars'
import { getSeminartypes } from '../../../../../redux/actions/seminartypes'
import { IRootState } from '../../../../../redux/types'
import CustomChip from '../../../../shared/components/CustomChip'
import Header from '../../../../shared/components/Header'
import NotFilter from '../../../../shared/components/NotFilter'
import TypeFilter from '../../../../shared/components/TypeFilter'
import CountriesFilter from '../../../../shared/components/filters/CountryFilter'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import ScrollSubheader from '../../../../shared/styles/ScrollSubHeader'
import { ActionsResponsive, ActionsResponsiveRight } from '../../../../shared/styles/SeminarGlobalStyles'
import SubHeader from '../../../../shared/styles/Subheader'
import { IFilter } from '../../models/Seminars'
import SeminarModal from '../components/SeminarModal'
import SeminarsTable from '../components/Seminarstable'
import HiddenDesktop from '@/contexts/shared/styles/HiddenDesktop'

function Seminars() {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)

  const dispatch = useDispatch()
  const { seminars, loading, reload, showForm } = useSelector((state: IRootState) => state.seminar)
  const { seminartypes } = useSelector((state: IRootState) => state.seminartype)
  const { globalFamilyId, globalBrandId, globalCountriesId, globalLanguageId, globalOrderById } = useSelector(
    (state: IRootState) => state.global
  )

  const [filters, setFilters] = useState<IFilter>({
    seminartype_id: null,
    family_id: null,
    brand_id: null,
    countries: [],
    language_id: null,
    orderby_id: null
  })

  useEffect(() => {
    if (seminartypes.length === 0 && globalLanguageId !== null && globalCountriesId.length > 0)
      dispatch(
        getSeminartypes({
          language_id: globalLanguageId,
          countries_id: globalCountriesId
        })
      )
  }, [globalLanguageId, globalCountriesId])

  useEffect(() => {
    if (reload) {
      dispatch(
        getSeminars({
          family_id: globalFamilyId,
          brand_id: globalBrandId,
          countries: globalCountriesId,
          language_id: globalLanguageId,
          orderby_id: globalOrderById
        })
      )
    }
  }, [reload])

  useEffect(() => {
    setFilters({
      ...filters,
      seminartype_id: null,
      family_id: globalFamilyId,
      brand_id: globalBrandId,
      language_id: globalLanguageId,
      countries: globalCountriesId
    })
  }, [globalFamilyId, globalBrandId, globalCountriesId, globalLanguageId, globalOrderById])

  useEffect(() => {
    if (filters.language_id !== null && filters.countries.length > 0) dispatch(getSeminars(filters))
  }, [filters])

  const handleChangeFilter = (seminartype_id: number) => {
    setFilters({ ...filters, seminartype_id })
  }

  return (
    <>
      {showForm && <SeminarModal />}

      <Header title={t('seminars')} />
      <SubHeader>
        <ScrollSubheader>
          <TypeFilter
            id={null}
            type={t('all')}
            categories={[]}
            active={filters.seminartype_id === null}
            handleChangeFilter={handleChangeFilter}
          />
          {seminartypes.map((seminartype: any, _index: number) => (
            <TypeFilter
              key={seminartype.id}
              id={seminartype.id}
              type={seminartype.name}
              categories={[]}
              active={seminartype.id === filters.seminartype_id}
              handleChangeFilter={handleChangeFilter}
            />
          ))}
          <HiddenDesktop>
            <IconButton
              sx={{
                position: 'absolute',
                right: 0,
                top: '17%',
                zIndex: 10,
                backgroundColor: 'white'
              }}
              className="buttonScroll"
            >
              <DoubleArrow />
            </IconButton>
          </HiddenDesktop>
        </ScrollSubheader>
      </SubHeader>

      <Container maxWidth="lg">
        <Box
          mt={isMobile ? 2 : 6}
          gap={2}
          display="flex"
          flexDirection='column'
        >
          <Box display="flex" justifyContent="center">
            <Typography variant="h5" align="center">
              {t('all')}
            </Typography>
            <Tooltip
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 600 }}
              arrow
              title={
                <Box>
                  <Typography variant="body2">{t('status')}:</Typography>
                  <Box display="flex" gap={8} alignItems="center">
                    <CustomChip size="small" color={'primary'} />
                    <Typography variant="caption">{t('active')}</Typography>
                  </Box>
                  <Box display="flex" gap={8} alignItems="center">
                    <CustomChip size="small" color={'secondary'} />
                    <Typography variant="caption">{t('inactive')}</Typography>
                  </Box>
                </Box>
              }
            >
              <IconButton>
                <InfoOutlined htmlColor={'#8F99A3'} fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
          <Box>
            <Grid container justifyContent="space-between" spacing={0}>
              <ActionsResponsive item xs={5} sm={6}>
                <Button id="btn-create-seminar" variant="outlined" color="secondary" onClick={() => dispatch(toggleFormSeminar(true))}>
                  {`${t('create')} ${t('live-event')}`}
                </Button>
              </ActionsResponsive>
              <ActionsResponsiveRight item xs={7} sm={6}>
                <CountriesFilter />
              </ActionsResponsiveRight>
            </Grid>
          </Box>

          {seminars.length === 0 && !loading ? <NotFilter /> : <SeminarsTable />}
        </Box>
      </Container>
    </>
  )
}

export default Seminars
